<template>
  <div class="video-wrap">
    <iframe
      ref="iframe"
      :src="`https://www.youtube.com/embed/${ytId}`"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    >
    </iframe>
  </div>
</template>

<script>
export default {
  props: ["ytId"],
  methods: {
    setIframeH() {
      let iframe = this.$refs.iframe;
      var iframeW = iframe.offsetWidth;
      let iframeH = Math.round(iframeW / (560 / 315));
      iframe.height = iframeH;
    },
  },
  mounted() {
    this.setIframeH();
    window.addEventListener("resize", this.setIframeH);
  },
  destroyed() {
    window.removeEventListener("resize", this.setIframeH);
  },
};
</script>
<style lang="scss">
.video-wrap {
    // padding: 15px;
    max-width: 1200px;
    margin: 0 auto 55px;
}
    
</style>